<template>
  <div class="allDiscussionBox">
    <div class="main">
      <mescroll-vue
      ref="mescroll"
      :down="allmescrollDown"
      :up="allmescrollUp"
      @init="allmescrollInit"
      class="allmescroll"
      >
      <Discussion :discussionList="discussionList" :systemtime="systemtime" :info="info" v-on:callBack="callBack"></Discussion>
      </mescroll-vue>
    </div>
    <Report
      :showBox="showBox"
      :reportData="reportData"
      :reportTop="reportTop"
      v-on:reportCallback="reportCallback"
      :community="community"
    ></Report>
  </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import Discussion from "./components/discussion";
import Report from "../course/components/report";

export default {
  metaInfo() {
    return {
      title: "全部动态",
    };
  },
  data() {
    return {
      info: "",
      discussionList: [],
      systemtime: "",
      customerid: "",

      allmescroll: null, // mescroll实例对象
      allmescrollDown: {
        use: false,
        isLock: true,
      },
      allmescrollUp: {
        onScroll: this.srollEvent,
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: '<p class="upwarp-nodata">暂无更多数据</p>',
        page: {
          num: this[this.mescrollText],
          size: this.dynamicPageSize,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          // tip: "暂无相关数据~", //提示
        },
      },

      showBox: "",
      reportData: "",
      reportTop: "",
      community:1000, //举报 参数区分
    };
    
  },

  components: {
    Discussion,
    MescrollVue,
    Report,
  },

  created(){
    $("body").on("click", function (e) {
      if ($(e.target).parents(".report").length > 0) {
      } else {
       this.reportCallback();
      }
    });
  },

  mounted() {
    this.customerid = this.$route.query.customerid
      ? this.$route.query.customerid
      : "";//"841673097953148928"
      this.$previewRefresh();
    this.getCusthomerIndex();
  },
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    upCallback(page, mescroll) {
      this.getAllDiscussion(page.num, page.size, mescroll);
    },
    downCallback() {
      this.mescroll.resetUpScroll();
    },
    callBack(data){
      if (data.type == "report") {
        this.showBox = "report";
        this.reportTop = data.data.reportTop + 20;
        this.reportData = data.data.item;
      }
    },
    reportCallback(){
      this.showBox = "";
      this.reportTop ='';
      this.reportData ='';
    },

    getCusthomerIndex() {
      var _this = this;
      var obj = {
        businessid: this.customerid,
      };
      _this
        .$post("/iart-api-crm/api/crm/community/queryByCusthomerindex", obj)
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data;
            this.systemtime = res.systemtime;
          } else {
            this.util.toast({ msg: res.message });
          }
        });
    },

    getAllDiscussion(num, size, mescroll) {
      var obj = {
        currentCustomerId:this.customerid,
        pageSize: size,
        pageNum: num,
      };
      this.$post(
        "/iart-api-crm/api/crm/customerfeed/queryCustomerFeed",
        obj
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            this.discussionList = this.discussionList.concat(data);
            this.$nextTick(() => {
              mescroll.endSuccess(data.length);
            });
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.allDiscussionBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 16px;
  .main {
    flex: 1;
    overflow: auto;
  }
}
</style>